import { useEffect, useState } from 'react';
import { remoteConfig } from '../firebase';
import { getValue, fetchAndActivate } from 'firebase/remote-config';
import { getDefaultAppConfig } from '../assets/constants/defaultAppConfig';
export const useAppConfig = () => {
    const defaultConfig = getDefaultAppConfig();
    const [config, setConfig] = useState(defaultConfig);
    useEffect(() => {
        const getConfig = async () => {
            try {
                await fetchAndActivate(remoteConfig);
                const configStr = getValue(remoteConfig, 'APP_CONFIG').asString();
                let parsed = {};
                if (configStr) {
                    try {
                        parsed = JSON.parse(configStr);
                    }
                    catch (err) {
                        console.error('Error parsing APP_CONFIG:', err);
                    }
                }
                console.log("actualizacion", JSON.stringify(parsed));
                setConfig({ ...defaultConfig, ...parsed });
            }
            catch (err) {
                console.error('Error fetching APP_CONFIG:', err);
            }
        };
        getConfig();
    }, []);
    return config;
};
